export default __webpack_public_path__ + "static/media/opera.51fd434f.png";